import type { RouteObject } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { LeadsPage } from './LeadsPage';
import { LeadProfilePage } from './LeadProfilePage';
import { NewLeadPage } from './NewLeadPage';

export const routes: RouteObject[] = [
  { path: '/leads', element: <LeadsPage /> },
  { path: '/leads/new', element: <NewLeadPage /> },
  { path: '/leads/:id', element: <LeadProfilePage /> },
];

/** Sidebar badge: how many leads currently deserve attention. */
export function useNavCount(): number | undefined {
  const { data } = useQuery({
    queryKey: ['dashboard', 'nav'],
    queryFn: ({ signal }) => import('../../lib/api').then(({ api }) => api.get<{ attention: { total: number } }>('/api/dashboard', { signal })),
    staleTime: 120_000,
    select: (dashboard) => dashboard.attention.total,
  });
  return data;
}
